import type { CHIEvent } from "@/lib/eventsData";
import { getEventMemberConversionPath } from "@shared/memberConversion";

/**
 * Return a trusted HTTPS destination for an organizer-configured post-registration handoff.
 * Invalid or non-HTTPS URLs deliberately fall back to the local confirmation flow.
 */
export function getPostRegistrationRedirectUrl(
  event: Pick<CHIEvent, "registrationRedirectUrl">,
): string | undefined {
  const configuredUrl = event.registrationRedirectUrl;
  if (!configuredUrl) return undefined;

  try {
    const destination = new URL(configuredUrl);
    return destination.protocol === "https:" ? destination.toString() : undefined;
  } catch {
    return undefined;
  }
}

/**
 * Preserve the selected event while sending an unauthenticated visitor through
 * first-party passwordless sign-in. The login page independently validates this
 * local return path before navigating after a successful OTP verification.
 */
export function getInternalEventRegistrationLoginUrl(
  event: Pick<CHIEvent, "slug">,
): string {
  return `/login?returnTo=${encodeURIComponent(`/events/${event.slug}`)}`;
}

/**
 * Preserve the selected event while inviting a prospective attendee to create
 * a member profile before secure sign-in and registration.
 */
export function getInternalEventRegistrationCreateAccountUrl(
  event: Pick<CHIEvent, "slug">,
): string {
  return getEventMemberConversionPath(event.slug);
}
